var React = require('react');

function Gear (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("path",{"d":"M14,25.5c-0.2,0-3.7,0-7.1-1.9l-0.5-0.3v-9.6L2.8,14l-2-8.2l8.1-3.7L9.3,3c0.1,0.1,1.5,3.1,4.7,3.1c3.2,0,4.7-3,4.7-3.1\n\tl0.4-0.9l8.1,3.7l-2,8.2l-3.5-0.4v9.6l-0.5,0.3C17.9,25.5,14.2,25.6,14,25.5C14,25.5,14,25.5,14,25.5z M14,23.5L14,23.5\n\tc0,0,3,0,5.7-1.4V11.5l4,0.4l1.2-4.9L20,4.7c-0.8,1.2-2.8,3.4-6,3.4S8.9,6,8,4.7L3.2,6.9l1.2,4.9l4-0.4v10.7\n\tC11.2,23.5,14,23.5,14,23.5L14,23.5z","key":1})]);
}

Gear.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = Gear;

Gear.default = Gear;
